// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"309":"60fae0719361b918","923":"fa6fc526ee35a0f7"}[chunkId] + ".js";
};